/* eslint-disable sonarjs/no-duplicate-string */
import { defineMessages } from "react-intl";
import { useMessages } from "2g-hooks/intl";

const MESSAGES = defineMessages({
  title: {
    id: "b2b.zadost-editace-widget.title",
    defaultMessage: "Request {id}"
  },
  zakaznik: {
    id: "b2b.zadost-editace-widget.form.field.zakaznik",
    defaultMessage: "Customer"
  },
  uzivatel: {
    id: "b2b.zadost-editace-widget.form.field.uzivatel",
    defaultMessage: "User"
  },
  projekt: {
    id: "b2b.zadost-editace-widget.form.field.projekt",
    defaultMessage: "Project"
  },
  fixni: {
    id: "b2b.zadost-editace-widget.form.field.fixni",
    defaultMessage: "Fixed"
  },
  produkt: {
    id: "b2b.zadost-editace-widget.form.field.produkt",
    defaultMessage: "Product"
  },
  zdroj: {
    id: "b2b.zadost-editace-widget.form.field.zdroj",
    defaultMessage: "Resource"
  },
  termin: {
    id: "b2b.zadost-editace-widget.form.field.termin",
    defaultMessage: "Rezervation time"
  },
  doplnkoveSluzby: {
    id: "b2b.zadost-editace-widget.form.field.doplnkove-sluzby",
    defaultMessage: "Additional services"
  },
  poznamky: {
    id: "b2b.zadost-editace-widget.form.field.poznamka-zakaznika",
    defaultMessage: "Customer's notes"
  },
  poznamkaStrojvedouci: {
    id: "b2b.zadost-editace-widget.form.field.poznamka-strojvedouci",
    defaultMessage: "Train driver's note"
  },
  poznamkaSpravce: {
    id: "b2b.zadost-editace-widget.form.field.poznamka-spravce",
    defaultMessage: "Administrator's note"
  },
  historie: {
    id: "b2b.zadost-editace-widget.form.field.historie",
    defaultMessage: "History"
  },
  saveDialogTitle: {
    id: "b2b.zadost-editace-widget.save-dialog.title",
    defaultMessage: "Save notes"
  },
  buttonSubmit: {
    id: "b2b.zadost-editace-widget.form.button.submit",
    defaultMessage: "Saving request notes"
  },
  labelTitleDescription: {
    id: "b2b.zadost-editace-widget.title-description.label",
    defaultMessage: "Created"
  }
});

export default () => useMessages(MESSAGES);
